/* ==========================================================================
   PanelAccommodation > Client
   ========================================================================== */
/* Modules */
const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');

const MESSAGE_TYPE = {
    INFO: '--info',
    ERROR: '--error'
};
const MESSAGE_ICON = {
    INFO: 'info',
    ERROR: 'circle-cancel'
};

function renderMessage(instance, type) {
    const { config = {} } = instance;
    const { context = {} } = config;
    const { infoMessage, errorMessage } = instance.store.select('data');

    const message = {
        INFO: infoMessage,
        ERROR: errorMessage
    }[type];

    return `<div class="panel-accommodation__message panel-accommodation__message${MESSAGE_TYPE[type]}">
        ${ViewHelpers(context).icon(MESSAGE_ICON[type])}
        <p class="panel-accommodation__message-text">${message}</p>
    </div>`;
}

function addMessage(instance, type) {
    const inst = instance;
    const { config = {} } = instance;
    const { messageHook: messageHookConfig } = config;

    const { hasInfo, error } = inst.store.select('data');
    const messageHook = messageHookConfig || instance.hooks.rooms;
    const node = toNode(renderMessage(instance, type))[0];

    if (hasInfo || error) removeMessage(instance);

    /* Extend hooks */
    inst.hooks = {
        ...inst.hooks,
        message: node
    };

    messageHook.appendChild(node);

    /* Disable button */
    if (inst.addRoom) inst.addRoom.actions.disable();
}

function removeMessage(instance) {
    if (instance.hooks.message) instance.hooks.message.remove();

    /* Disable button */
    if (instance.addRoom) instance.addRoom.actions.enable();
}

module.exports = {
    addMessage,
    removeMessage
};
